<template>
  <div>
    <div class="custom-select-box d-inline-block multi-select" :tabindex="tabindex" ref="select-box" @focusout="handleFocusOut">
      <div class="selected" :class="{ open: open}" @click="open = !open">
        <span class="placeholder-text">{{placeholder}}</span>
      </div>
      <div ref="options" class="items" :class="{ selectHide: !open }">
        <div>
          <input
            type="text" 
            class="search-bar"
            placeholder="Add / search tags"
            v-model="searchOption"
          />
          <button type="button" class="add-button" 
            v-if="showAddButton" 
            @click="addNewOption()"
            :class="!!searchOption ? '' : 'disable-add-button'"
          >Add</button>
        </div>
        <div class="horizontal-divider"></div>
        <div class="multi-select-height">
          <div v-if="filteredOptions.length > 0">
            <div class="item" v-for="(option) of filteredOptions" :key="`multiple-choice-option-${option.id}`">
              <label class="select-options">
                <input :id="option.id" :value="{ id: option.id, body: option.body}" type="checkbox" v-model="selectedOptions">
                <span class></span>
                {{ option.body }}
              </label>
            </div>
          </div>
          <div v-else class="empty-options" v-html="noDataHTML"></div>
        </div>
      </div>
    </div>
    <div class="pt-10" v-if="showSelectedOptions">
        <div v-if="!!selectedOptions && selectedOptions.length" class="selected-options-chips">
            <span v-for="(opt, index) in selectedOptions"
                :key="index" class="chip"
            >{{opt.body}} 
              <span @click="$delete(selectedOptions, index)" class="fa fa-times-circle"></span>
            </span>            
        </div>
    </div>
  </div>
</template>
  
<script>
import button from '../common/button.vue';
export default {
  components: { button },
  name: "MultiSelectWithSearch",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOptionId: {
      type: Array
    },
    placeholder:{
      type: String,
      required: true
    },
    showAddButton:{
      type: Boolean,
      required: false,
      default: false
    },
    noDataHTML:{
      type: String,
      required: false,
      default: '<span>Data not found. <br> Click “Add” to create new data.</span>'
    },
    showSelectedOptions:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    selectedOptions: {
      deep: true,
      handler(value) {
        this.$emit("onSelect", value);
      }
    },
  },
  data() {
    return {
      selectedOptions: this.selectedOptionId,
      open: false,
      searchOption: "",
      optionList: this.options
    };
  },
  computed:{
    filteredOptions (){
      if(!!this.searchOption && this.optionList.length > 0){
        return this.optionList.filter((item)=>{
          return item.body.startsWith(this.searchOption);
        })
      }else{
        return this.optionList;
      }
    }
  },
  methods: {
    handleFocusOut(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.open = false;
        this.searchOption = "";
      }
    },
    addNewOption(){
      if(!!this.searchOption){
        let newObject = {
          body:this.searchOption, 
          id:'id' + (new Date()).getTime()
        }
        this.optionList.unshift(newObject);
        this.selectedOptions.push(newObject);
        this.searchOption = "";
      }
    },
    sortOptions(a,b){
      if(a.body < b.body){
          return -1;
        }else if(a.body > b.body){
          return 1;
        }else{
          return 0;
      }
    }
  },
  mounted(){
    this.optionList.sort(this.sortOptions);
  }
};
</script>
  
<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;
    .selected {
      background-color: #ffffff;
      border-radius: 4px;
      border: solid 1px #d3dfe4;
      color: #4a4a4a;
      padding: 7px;
      padding-left: 11px;
      cursor: pointer;
      user-select: none;
      text-transform: capitalize;
          &:after {
            position: absolute;
            content: "";
            top: 13px;
            right: 10px;
            width: 0;
            height: 0;
            border: 6px solid transparent;
            border-color: #b0bac9 transparent transparent transparent;
          }
    }
  
    .items {
      color: #4a4a4a;
      border-radius: 4px;
      position: absolute;
      background-color: #ffffff;
      left: 0px;
      right: 0px;
      top: 0px;
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
      z-index: 1;
      min-width: 316px;
      max-height: 500px;
      padding: 16px;
      font-size: 14px;
  
      scrollbar-width: thin;
      /* "auto" or "thin"  */
      scrollbar-color: #e6e9ed transparent;
  
      /* scroll thumb & track */
      &::-webkit-scrollbar {
          width: 7px;
          /* width of the entire scrollbar */
      }
  
      &::-webkit-scrollbar-track {
        background: transparent;
        /* color of the tracking area */
      }
  
      &::-webkit-scrollbar-thumb {
        background-color: #c5d1d6;
        /* color of the scroll thumb */
        border-radius: 20px;
        /* roundness of the scroll thumb */
        border: 3px solid transparent;
      /* creates padding around scroll thumb */
      }
  
      .item {
        cursor: pointer;
        user-select: none;
        margin-bottom: 4px;
        &:hover {
          background-color: #f8f9fa;
        }
        &:last-of-type {
          margin-bottom: 0;
        }
  
        /*checkbox data*/
  
        label {
          width: 100%;
          cursor: pointer;
  
        span {
          vertical-align: middle;
          margin-right: 5px;
  
        }
      }
  
      input[type="checkbox"] {
        display: none;
        height: 16px;
        width: 16px;
      }
  
      input[type="checkbox"]+span:before {
        content: "";
        border: 0.1em solid #959fa4;
        border-radius: 4px;
        width: 16px;
        height: 16px;
        padding: 4px;
        color: transparent;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center center;
        display: inline-block;
        margin-top: 2px;
      }
  
      input[type="checkbox"]:checked+span:before {
        background-color: #4c8ce4;
        border: 0.1em solid #4c8ce4;
        color: #fff;
        background-image: url(/static/img/checked-checkbox.svg);
      }
    }
  }
}
  
.selectHide {
  display: none;
}

.placeholder-text{
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #979797;
}

.search-bar {
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  width: 275px;
  height: 37px;
  padding-right: 50px;
}
.multi-select-height{
  overflow-x: hidden;
  overflow-y: auto;
  height: 190px;
  padding-top: 10px;
}
.add-button {
  margin-left: -56px;
  height: 25px;
  width: 50px;
  border: solid 1px #4c8ce4;
  background-color: #4c8ce4;
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
}

.empty-options{
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
}
.disable-add-button{
  opacity: 0.5;
}

.horizontal-divider{
  height: 15px;
  border-bottom: 1px solid #d3dee3;
  width: 316px;
  margin-left: -16px;
}

.selected-options-chips {
    font-size: 12px;
    vertical-align: middle;

    .chip {
        padding: 5px 12px;
        border-radius: 4px;
        color: #4a4a4a;
        background-color: #e0e0e0;
        margin-right: 10px;
        margin-bottom: 4px;
        display: inline-block;

        .fa {
            color: #666669;
            vertical-align: middle;
            cursor: pointer;
            font-size: 15px;
            margin-left: 5px;
        }

        &:last-of-type {
            margin-right: 0;
        }
    }

}

.multi-select{
    width: 232px;
    border-radius: 4px;
    border: solid 1px #d3dfe4;
    background-color: #fff;
}
</style>
  